import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { JSON_ONE11} from "./JSON_DATA_Requestflowone";
import { JSON_ONE21 } from "./JSON_DATA_Responseflowone";
import { JSON_ONE31 } from "./JSON_DATA_Requestflowtwo";
import { JSON_ONE41 } from "./JSON_DATA_Responseflowtwo";
import { JSON_ONE42} from "./JSON_DATA_Requestflowthree";
import { JSON_ONE43 } from "./JSON_DATA_Responseflowthree";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
import RequestJSONflowone from './RequestJSONflowone';
import ResponseJSONflowone from './ResponseJSONflowone';
import RequestJSONflowtwo from './RequestJSONflowtwo';
import ResponseJSONflowtwo from './ResponseJSONflowtwo';
import RequestJSONflowthree from './RequestJSONflowthree';
import ResponseJSONflowthree from './ResponseJSONflowthree';
function ECollectAPI() {
const [ShowHideAccordion, SetShowHideAccordion] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const [ShowHideAccordionThree, SetShowHideAccordionThree] = useState(false);
const onClickAccordianShowHide = () => {
SetShowHideAccordion(!ShowHideAccordion)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const onClickAccordianShowHideThree = () => {
SetShowHideAccordionThree(!ShowHideAccordionThree)
}
const [TabCheck, SetTabCheck] = useState(false)
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab = () => {
SetTabCheck(!TabCheck);
}
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>E-Collect API</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2 id='create-van-pg-sec'>Create VAN</h2>
            <p className="mt-30">SafexPay services provide trustworthy and feasible solutions to their registered merchants.
               Register as a merchant with us to know more about the features of Safexpay Payment Gateway kit which allows 
               merchants to instantly collect payments from their users using various payment modes like credit cards,
               debit cards, cash cards, net banking etc. To read more please <i><a href="assets/pdf/E-Collect API.pdf"><span className="col-org">Click here</span></a></i> to download detailed documentation for E-Collect API.
            </p>
            <u>
               <h5>API List for E-Collect:</h5>
            </u>
            <ol>
               <li>Create Virtual Account API</li>
               <li>Close Virtual Account API</li>
               <li>Fetch Transaction</li>
               <li>Fetch VAN list</li>
            </ol>
            <h5>Create Virtual Account API:</h5>
            <ul>
               <li>Merchant must execute this service to create a virtual account for each customer.</li>
               <li>Merchant must send customer details on request along with other parameters.</li>
               <li>In response, the merchant will get the beneficiary details on which customer will make the payment.</li>
               <li>The virtual account number will be unique for each customer and can make multiple payments against it.</li>
            </ul>
            <p>
               {/* <b>UAT URL:</b> <span className="col-red">https://pguat.safexpay.com/agcore/api/vpa/post</span> */}
               <b>UAT URL :</b> <span className="col-red">https://uatcheckout.safexpay.com/agcore/api/vpa/post</span>
            </p>
            <p>
               {/* <b>Production URL :</b> <span className="col-red">https://www.avantgardepayments.com/agcore/api/vpa/post</span> */}
               <b>Production URL :</b> <span className="col-red">https://checkout.safexpay.com/agcore/api/vpa/post</span>
            </p>
            <u>
               <h5>Aes256 Crypto logic</h5>
            </u>
            <p>
               It is used to create the encrypt and decrypt JSON Request and Response parameters respectively.
            </p>
            <u>
               <h5>Iv- initialization vector</h5>
            </u>
            <p>
               It can be used along with the Encryption key for data encryption and the value remains the constant which is mentioned in the Integration kit.
            </p>
            <u>
               <h5>Postman Collection</h5>
            </u>
            <p>We are providing the postman collection to check the transaction status on easier way. Safexpay team will share you at the time of Integration.</p>
            <u>
               <h5>Merchant key</h5>
            </u>
            <p>It is used to Encrypt and Decrypt the Request and response parameters.</p>
            <u>
               <h5>Please find the credentials shared below to check the API flow:</h5>
            </u>
            <p><b>UAT Merchant ID:</b> 202107090001</p>
            <p><b>UAT Encryption Key:</b> wR4N7nxdBne3spWjO6MnRtelU3Ryqf+7w6nCcx5fFM8=</p>
            <p><b>Aggregator ID:</b> Paygate</p>
            <h5>Plain Request:</h5>
            <div class="form-data1">
            <pre id="json">      {'\u007B'}{'\n'}
        "ag_id": "paygate",{'\n'}
        "me_id": "202107090001",{'\n'}
        "request_type": "Create Virtual Account",{'\n'}
        "channel": "WEB",{'\n'}
        "me_order_id": "78sdsd61340031",{'\n'}
        "pg_id": "615",{'\n'}
        "cust_name": "Rutuja",{'\n'}
        "cust_email_id": "abcz@safexpay.com",{'\n'}
        "cust_mobile_no": "7887936877",{'\n'}
        "cust_account_number": "5323445678136109",{'\n'}
        "cust_ifsc_code": "SBIN0005943",{'\n'}
        "cust_bank_Name": "SBI BANK",{'\n'}
        "udf_1":"123"{'\n'}
        {'\u007D'}
    </pre>
            </div>
            <h5>Plain Response:</h5>
            <div class="form-data1">
            <pre id="json">      {'\u007B'}{'\n'}
        "me_id":"202107090001",{'\n'}
        "acc_creation_datetime":"Sep 22, 2021 12:38:05PM",{'\n'}
        "status":"Active",{'\n'}
        "status_code":"0",{'\n'}
        "description":"Virtual Account Number Created successfully!",{'\n'}
        "virtual_acc_no":"61102909000137422867",{'\n'}
        "bene_IFSC_Code":"YESB0CMSNOC",{'\n'}
        "bene_Bank_name":"Yes Bank",{'\n'}
        "bene_name":"NIKE NEW AWS",{'\n'}
        "me_order_id":"78sdsd61340031",{'\n'}
        "ag_order_id":"37422867",{'\n'}
        "udf_1":"123"{'\n'}
        {'\u007D'}
    </pre>
            </div>
            <u>
               <p>
                  AUTHORIZATIONS:
               </p>
            </u>
            <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
            <hr className='hr-col'>
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The Aggregator id like “paygate”. We willprovide the value to be passed.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant ID issued to you by Safexpay.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>AG_ref id generated by the Safexpay during the transaction. It should be encrypted format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="channel"><span class="sc-iemWCZ fhDkLh"></span><span>channel</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Use “WEB” in case of website based payment or “MOBILE” in case of mobile app.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_order_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_order_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is the unique order number generated at your end when the request is initiated.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>List will be provided to you. E.g. “1” for HDFC Bank.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>List will be provided to you. NE = NEFT/RTGS</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="scheme"><span class="sc-iemWCZ fhDkLh"></span><span>scheme</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Pass hardcoded value “7” for NA.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_name</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Customer Name. This is required.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_email_id"><span class="sc-iemWCZ fhDkLh"></span><span>cust_email_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Customer’s Email ID. This is required and should be a valid email address.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_mobile_no"><span class="sc-iemWCZ fhDkLh"></span><span>cust_mobile_no</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Customer’s Mobile Number</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_ref_num"><span class="sc-iemWCZ fhDkLh"></span><span>cust_ref_num</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Customer’s Unique number generated in your system.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_account_number"><span class="sc-iemWCZ fhDkLh"></span><span>cust_account_number</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is the registered bank account number of customer. Required in case of TPV</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_ifsc_code"><span class="sc-iemWCZ fhDkLh"></span><span>cust_ifsc_code</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is the IFSC code of the registered bank account number. Required in case of TPV</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_bank_Name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_bank_Name</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is the registered bank name of customer. Required in case of TPV</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_bankbranch_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_bankbranch_name</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is the branch name of the customer's bank. Example – Dadar</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_bankcity_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_bankcity_name</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is the city name of the customer's bank. Example – Mumbai</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_1"><span class="sc-iemWCZ fhDkLh"></span><span>udf_1</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is a user defined field that you can use to send any additional information about the transaction.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_2"><span class="sc-iemWCZ fhDkLh"></span><span>udf_2</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is a user defined field that you can use to send any additional information about the transaction.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
            <h5>Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                        <b>200</b> A refund response json object  {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <div class="card-body">
                     <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/json</span></h6>
                     <hr class="hr-col">
                     </hr>
                     <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>publishId Request Received</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="acc_creation_datetime"><span class="sc-iemWCZ fhDkLh"></span><span>acc_creation_datetime</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Auth Request Received</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Fraud Details</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status_code"><span class="sc-iemWCZ fhDkLh"></span><span>status_code</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Other Details</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="description"><span class="sc-iemWCZ fhDkLh"></span><span>description</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Virtual Account Number Created successfully!</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bene_IFSC_Code"><span class="sc-iemWCZ fhDkLh"></span><span>bene_IFSC_Code</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>IFSC code of Beneficiary account</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bene_Bank_name"><span class="sc-iemWCZ fhDkLh"></span><span>bene_Bank_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Beneficiary Bank name</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bene_name"><span class="sc-iemWCZ fhDkLh"></span><span>bene_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Beneficiary name</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_order_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_order_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>This is the unique order number generated at your end when the request is initiated.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_order_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_order_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>This is the unique order number generated at Safexpay end when the request is received.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_1"><span class="sc-iemWCZ fhDkLh"></span><span>udf_1</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Same value as given in request</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr class="last undefined">
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_2"><span class="sc-iemWCZ fhDkLh"></span><span>udf_2</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Same value as given in request</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>400 Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>404 Not found</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>500 server-error</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
               </div>
            </div>
            <div class="card mb-60">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(252 239 239)", color: "rgb(212, 31, 28)", padding: "10px 15px" }} onClick={onClickCangeTab2}>
                     <b>default</b> Succesfull Transaction  {TabCheck2 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck2 &&
            <div>
               <div class="card-body">
                  <h6 class="mt-10"><span>Response Schema:  </span>  <span style={{ color: "#313131" }}>Application/x-www-form-urlencode</span></h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 10 </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Aggregator ID.It's value must be AvantGarde</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Merchant Id issued by Avantgrade</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is your Transaction ID for which you have initiated payment.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;double&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is your Transaction Amount.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Country"><span class="sc-iemWCZ fhDkLh"></span><span>Country</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>ISO Country Code.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Currency"><span class="sc-iemWCZ fhDkLh"></span><span>Currency</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>ISO Currency Code.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 10 characters </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>The transaction date and must be supplied in DD-MM-YY format.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 8 characters </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>The transaction time and must be supplied in HH:MM:SS format.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is Transaction ID generated by aggregator for which you have initiated payment.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is Transaction ID generated by gateway for which you have initiated payment.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Successful"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Failed"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Holding"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Pending"</span> </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Transaction Status </p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 5 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Response Code. "0" for Success</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 200 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Response message explaining the failure reason. "0" for Success</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr className='expanded'>
                           <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHide}>
                              <span className='sc-iemWCZ fhDkLh'></span>
                              <span>
                                 pg-details {ShowHideAccordion ? 
                                 <FaAngleDown/>
                                 : 
                                 <FaAngleUp/>
                                 }
                              </span>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                    <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                 </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        {ShowHideAccordion &&
                        <tr>
                           <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                              <div className="sc-dIvrsQ kPKTxr">
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="senderKey"><span class="sc-iemWCZ fhDkLh"></span><span>senderKey</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;base64&gt; </span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>public key identifying the sender of the payload</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 3 ] </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Bank Number. E.g. “1” for HDFC Bank</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 50 ] </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Bank Name</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"NB"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"DC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"PP"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"WA"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CE"</span> </div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Provides details about the paymode.<br/>
                                                         Valid values:<br/>
                                                      </p>
                                                      <ul>
                                                         <li>NB: Net Banking</li>
                                                         <li>CC: Credit Card</li>
                                                         <li>DC: Debit Card</li>
                                                         <li>PP: Prepaid Card</li>
                                                         <li>WA: Wallet</li>
                                                         <li>CE: Credit Card EMI</li>
                                                      </ul>
                                                      <p></p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"3"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"6"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"9"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"12"</span> </div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Tenure of EMI (3/6/9/12).Paymode must be Credit Card EMI (CCE).</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        }
                        <tr className='expanded'>
                           <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                              <span className='sc-iemWCZ fhDkLh'></span>
                              <span>
                                 fraud_details {ShowHideAccordionTwo ? 
                                 <FaAngleDown/>
                                 : 
                                 <FaAngleUp/>
                                 }
                              </span>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                    <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                 </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        {ShowHideAccordionTwo &&
                        <tr>
                           <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                              <div className="sc-dIvrsQ kPKTxr">
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Accept"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Reject"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Review"</span> </div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Provides details about the fraud action. <br/>
                                                         Only if fraud engine is selected <br/>
                                                         Valid values:<br/>
                                                      </p>
                                                      <ul>
                                                         <li>Accept: Fraud not suspected. </li>
                                                         <li>Reject: Very strong fraud suspicion, reject the order. </li>
                                                         <li>Review:  Fraud suspected, review the customer details before processing the order. </li>
                                                      </ul>
                                                      <p></p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Fraud message describes the fraud in details.Only if fraud engine is selected.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Risk scale</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        }
                        <tr className='expanded last undefined'>
                           <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideThree}>
                              <span className='sc-iemWCZ fhDkLh'></span>
                              <span>
                                 other_details {ShowHideAccordionThree ? 
                                 <FaAngleDown/>
                                 : 
                                 <FaAngleUp/>
                                 }
                              </span>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                    <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                 </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        {ShowHideAccordionThree &&
                        <tr>
                           <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                              <div className="sc-dIvrsQ kPKTxr">
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf1"><span class="sc-iemWCZ fhDkLh"></span><span>udf1</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf2"><span class="sc-iemWCZ fhDkLh"></span><span>udf2</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf3"><span class="sc-iemWCZ fhDkLh"></span><span>udf3</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf4"><span class="sc-iemWCZ fhDkLh"></span><span>udf4</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf5"><span class="sc-iemWCZ fhDkLh"></span><span>udf5</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        }
                     </tbody>
                  </table>
               </div>
            </div>
            }
         </div>
      </div>
   </div>
   <div class="col-md-4 extreme-rt-div">
      <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
                  <button> POST </button> /agcore/api/vpa/post  {TabCheck ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck &&
         <div>
            <br />
            <div class="card-body">
               <p class="mb-0">Production server (uses live data)</p>
               <div class="api-div-bor">
                  <span>https://www.avantgardepayments.com</span><span
                     class="col-org">/agcore/api/vpa/post</span>
               </div>
               <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
               <div class="api-div-bor">
                  <span>https://pguat.safexpay.com</span><span
                     class="col-org">/agcore/api/vpa/post</span>
               </div>
            </div>
         </div>
         }
      </div>
   </div>
   <RequestJSON/>
   <ResponseJSON/>
</div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div class="col-md-8 mt-60">
      <h2 id='close-van-pg-sec'>Close VAN</h2>
      <p>Merchant will execute this api if he wants to close the account created for a customer.</p>
      {/* <p><b>UAT URL:</b> <span class="col-red">https://pguat.safexpay.com/agcore/api/vpa/delete</span></p>
      <p><b>Production URL:</b><span class="col-red"> https://www.avantgardepayments.com/agcore/api/vpa/delete</span></p> */}

      <p><b>UAT URL :</b> <span class="col-red">https://uatcheckout.safexpay.com/agcore/api/vpa/delete</span></p>
      <p><b>Production URL : </b><span class="col-red">https://checkout.safexpay.com/agcore/api/vpa/delete</span></p>
      <u>
         <p>
            AUTHORIZATIONS:
         </p>
      </u>
      <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
      <hr className='hr-col'>
      </hr>
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>The Aggregator id like “paygate”. We willprovide the value to be passed.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Merchant ID issued to you by Safexpay.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>AG_ref id generated by the Safexpay during the transaction. It should be encrypted format.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="channel"><span class="sc-iemWCZ fhDkLh"></span><span>channel</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Use “WEB” in case of website based payment or “MOBILE” in case of mobile app.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_email_id"><span class="sc-iemWCZ fhDkLh"></span><span>cust_email_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Customer’s Email ID. This is required and should be a valid email address.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_mobile_no"><span class="sc-iemWCZ fhDkLh"></span><span>cust_mobile_no</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Customer’s Mobile Number</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_account_number"><span class="sc-iemWCZ fhDkLh"></span><span>cust_account_number</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>This is the registered bank account number of customer. Required in case of TPV</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5>Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                  <b>200</b> A refund response json object  {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <div class="card-body">
               <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/json</span></h6>
               <hr class="hr-col">
               </hr>
               <table class="sc-hHEiqL iZJLLY">
                  <tbody>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>publishId Request Received</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="acc_creation_datetime"><span class="sc-iemWCZ fhDkLh"></span><span>acc_creation_datetime</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Auth Request Received</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Fraud Details</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status_code"><span class="sc-iemWCZ fhDkLh"></span><span>status_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Other Details</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="description"><span class="sc-iemWCZ fhDkLh"></span><span>description</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Virtual Account Number Created successfully!</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="virtual_acc_no"><span class="sc-iemWCZ fhDkLh"></span><span>virtual_acc_no</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Account number of Beneficiary account</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr class="last undefined">
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_order_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_order_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the unique order number generated at Safexpay end when the request is received.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>400 Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>404 Not found</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>500 server-error</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
         </div>
      </div>
      <div class="card mb-60">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(252 239 239)", color: "rgb(212, 31, 28)", padding: "10px 15px" }} onClick={onClickCangeTab2}>
               <b>default</b> Succesfull Transaction  {TabCheck2 ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck2 &&
      <div>
         <div class="card-body">
            <h6 class="mt-10"><span>Response Schema:  </span>  <span style={{ color: "#313131" }}>Application/x-www-form-urlencode</span></h6>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 10 </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Aggregator ID.It's value must be AvantGarde</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant Id issued by Avantgrade</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is your Transaction ID for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;double&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is your Transaction Amount.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Country"><span class="sc-iemWCZ fhDkLh"></span><span>Country</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>ISO Country Code.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Currency"><span class="sc-iemWCZ fhDkLh"></span><span>Currency</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>ISO Currency Code.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 10 characters </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The transaction date and must be supplied in DD-MM-YY format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 8 characters </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The transaction time and must be supplied in HH:MM:SS format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is Transaction ID generated by aggregator for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is Transaction ID generated by gateway for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Successful"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Failed"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Holding"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Pending"</span> </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Transaction Status </p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 5 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Response Code. "0" for Success</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 200 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Response message explaining the failure reason. "0" for Success</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHide}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           pg_details {ShowHideAccordion ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordion &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="senderKey"><span class="sc-iemWCZ fhDkLh"></span><span>senderKey</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;base64&gt; </span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>public key identifying the sender of the payload</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 3 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Bank Number. E.g. “1” for HDFC Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 50 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Bank Name</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"NB"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"DC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"PP"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"WA"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CE"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Provides details about the paymode.<br/>
                                                   Valid values:<br/>
                                                </p>
                                                <ul>
                                                   <li>NB: Net Banking</li>
                                                   <li>CC: Credit Card</li>
                                                   <li>DC: Debit Card</li>
                                                   <li>PP: Prepaid Card</li>
                                                   <li>WA: Wallet</li>
                                                   <li>CE: Credit Card EMI</li>
                                                </ul>
                                                <p></p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"3"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"6"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"9"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"12"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Tenure of EMI (3/6/9/12).Paymode must be Credit Card EMI (CCE).</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           fraud_details {ShowHideAccordionTwo ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionTwo &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Accept"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Reject"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Review"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Provides details about the fraud action. <br/>
                                                   Only if fraud engine is selected <br/>
                                                   Valid values:<br/>
                                                </p>
                                                <ul>
                                                   <li>Accept: Fraud not suspected. </li>
                                                   <li>Reject: Very strong fraud suspicion, reject the order. </li>
                                                   <li>Review:  Fraud suspected, review the customer details before processing the order. </li>
                                                </ul>
                                                <p></p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Fraud message describes the fraud in details.Only if fraud engine is selected.</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Risk scale</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
                  <tr className='expanded last undefined'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideThree}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           other_details {ShowHideAccordionThree ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionThree &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf1"><span class="sc-iemWCZ fhDkLh"></span><span>udf1</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf2"><span class="sc-iemWCZ fhDkLh"></span><span>udf2</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf3"><span class="sc-iemWCZ fhDkLh"></span><span>udf3</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf4"><span class="sc-iemWCZ fhDkLh"></span><span>udf4</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf5"><span class="sc-iemWCZ fhDkLh"></span><span>udf5</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
               </tbody>
            </table>
         </div>
      </div>
      }
   </div>
</div>
</div>
<div class="col-md-4 extreme-rt-div">
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
               <button> POST </button> /agcore/api/vpa/delete  {TabCheck ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com</span><span
                  class="col-org">/agcore/api/vpa/delete</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com</span><span
                  class="col-org">/agcore/api/vpa/delete</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<RequestJSONflowone/>
<ResponseJSONflowone/>
</div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div class="col-md-8 mt-60">
      <h2 id='fetch-transaction-pg-sec'>Fetch Transaction</h2>
      <ul>
         <li>Merchant can fetch the status of the transaction/s basis of customer details like account number, mobile number, or date.</li>
         <li>Date is a required parameter.</li>
      </ul>
      {/* <p><b>UAT URL:</b> <span class="col-red">https://test.avantgardepayments.com/agcore/api/VAStatus/post</span></p>
      <p><b>Production URL:</b> <span class="col-red">https://www.avantgardepayments.com/agcore/api/VAStatus/post</span></p> */}


<p><b>UAT URL :</b> <span class="col-red">https://uatcheckout.safexpay.com/agcore/api/VAStatus/post</span></p>
      <p><b>Production URL :</b> <span class="col-red">https://checkout.safexpay.com/agcore/api/VAStatus/post</span></p>

      <u>
         <p>AUTHORIZATIONS:</p>
      </u>
      <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
      <hr className='hr-col'>
      </hr>
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>The Aggregator id like “paygate”. We willprovide the value to be passed.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Merchant ID issued to you by Safexpay.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>AG_ref id generated by the Safexpay during the transaction. It should be encrypted format.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_account_number"><span class="sc-iemWCZ fhDkLh"></span><span>cust_account_number</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>This is the registered bank account number of customer. Required in case of TPV</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Txn_date_range"><span class="sc-iemWCZ fhDkLh"></span><span>Txn_date_range</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Date of transaction always required. If you want to fetch transaction from to date, you must pass the daterange. If you want to fetch transaction of one day the to and from date will be same. Format DD-MM-YYYY to DD-MM-YYYY. E.g., 26-11-2015 to 28-11-2015</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5>Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                  <b>200</b> Encrypted Response Format  {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <div class="card-body">
               <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/json</span></h6>
               <hr class="hr-col">
               </hr>
               <table class="sc-hHEiqL iZJLLY">
                  <tbody>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="error_code"><span class="sc-iemWCZ fhDkLh"></span><span>error_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>NO_DATA_FOUND</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr class="last undefined">
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="error_message"><span class="sc-iemWCZ fhDkLh"></span><span>error_message</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Auth Request Received</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>400 Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>404 Not found</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>500 server-error</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
         </div>
      </div>
      <div class="card mb-60">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(252 239 239)", color: "rgb(212, 31, 28)", padding: "10px 15px" }} onClick={onClickCangeTab2}>
               <b>default</b> Succesfull Transaction  {TabCheck2 ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck2 &&
      <div>
         <div class="card-body">
            <h6 class="mt-10"><span>Response Schema:  </span>  <span style={{ color: "#313131" }}>Application/x-www-form-urlencode</span></h6>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 10 </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Aggregator ID.It's value must be AvantGarde</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant Id issued by Avantgrade</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is your Transaction ID for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;double&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is your Transaction Amount.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Country"><span class="sc-iemWCZ fhDkLh"></span><span>Country</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>ISO Country Code.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Currency"><span class="sc-iemWCZ fhDkLh"></span><span>Currency</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>ISO Currency Code.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 10 characters </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The transaction date and must be supplied in DD-MM-YY format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 8 characters </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The transaction time and must be supplied in HH:MM:SS format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is Transaction ID generated by aggregator for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is Transaction ID generated by gateway for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Successful"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Failed"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Holding"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Pending"</span> </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Transaction Status </p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 5 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Response Code. "0" for Success</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 200 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Response message explaining the failure reason. "0" for Success</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHide}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           pg_details {ShowHideAccordion ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordion &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="senderKey"><span class="sc-iemWCZ fhDkLh"></span><span>senderKey</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;base64&gt; </span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>public key identifying the sender of the payload</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 3 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Bank Number. E.g. “1” for HDFC Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY  col-red"> [ 1 .. 50 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Bank Name</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"NB"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"DC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"PP"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"WA"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CE"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Provides details about the paymode.<br/>
                                                   Valid values:<br/>
                                                </p>
                                                <ul>
                                                   <li>NB: Net Banking</li>
                                                   <li>CC: Credit Card</li>
                                                   <li>DC: Debit Card</li>
                                                   <li>PP: Prepaid Card</li>
                                                   <li>WA: Wallet</li>
                                                   <li>CE: Credit Card EMI</li>
                                                </ul>
                                                <p></p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"3"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"6"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"9"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"12"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Tenure of EMI (3/6/9/12).Paymode must be Credit Card EMI (CCE).</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           fraud_details {ShowHideAccordionTwo ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionTwo &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Accept"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Reject"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Review"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Provides details about the fraud action. <br/>
                                                   Only if fraud engine is selected <br/>
                                                   Valid values:<br/>
                                                </p>
                                                <ul>
                                                   <li>Accept: Fraud not suspected. </li>
                                                   <li>Reject: Very strong fraud suspicion, reject the order. </li>
                                                   <li>Review:  Fraud suspected, review the customer details before processing the order. </li>
                                                </ul>
                                                <p></p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Fraud message describes the fraud in details.Only if fraud engine is selected.</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Risk scale</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
                  <tr className='expanded last undefined'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideThree}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           other_details {ShowHideAccordionThree ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionThree &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf1"><span class="sc-iemWCZ fhDkLh"></span><span>udf1</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf2"><span class="sc-iemWCZ fhDkLh"></span><span>udf2</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf3"><span class="sc-iemWCZ fhDkLh"></span><span>udf3</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf4"><span class="sc-iemWCZ fhDkLh"></span><span>udf4</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf5"><span class="sc-iemWCZ fhDkLh"></span><span>udf5</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
               </tbody>
            </table>
         </div>
      </div>
      }
   </div>
</div>
</div>
<div class="col-md-4 extreme-rt-div">
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
               <button> POST </button> /agcore/api/VAStatus/post  {TabCheck ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com</span><span
                  class="col-org">/agcore/api/VAStatus/post</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com</span><span
                  class="col-org">/agcore/api/VAStatus/post</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<RequestJSONflowtwo/>
<ResponseJSONflowtwo/>
</div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div class="col-md-8 mt-60">
      <h2 id='fetch-van-list-pg-sec'>Fetch VAN list</h2>
      <ul>
         <li>Merchant can use this service to fetch the virtual account number generated in our system for each customer.</li>
         <li>There will always be one account created for one customer.</li>
      </ul>
      {/* <p><b>UAT URL:</b><span class="col-red">https://pguat.safexpay.com/agcore/api/vpa/vaList</span></p>
      <p><b>Production URL:</b> <span class="col-red">https://www.avantgardepayments.com/agcore/api/vpa/vaList</span></p> */}

      <p><b>UAT URL :</b> <span class="col-red">https://uatcheckout.safexpay.com/agcore/api/vpa/vaList</span></p>
      <p><b>Production URL :</b> <span class="col-red">https://checkout.safexpay.com/agcore/api/vpa/vaList</span></p>
      <u>
         <p>AUTHORIZATIONS:</p>
      </u>
      <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
      <hr className='hr-col'>
      </hr>
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>The Aggregator id like “paygate”. We willprovide the value to be passed.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Merchant ID issued to you by Safexpay.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>AG_ref id generated by the Safexpay during the transaction. It should be encrypted format.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="channel"><span class="sc-iemWCZ fhDkLh"></span><span>channel</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>This is the registered bank account number of customer. Required in case of TPV</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="From"><span class="sc-iemWCZ fhDkLh"></span><span>From</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Date from when to fetchthe VA. Format DD-MM-YYYY. E.g., 26-11-2015</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="To"><span class="sc-iemWCZ fhDkLh"></span><span>To</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Date till when to fetch theVA. Format DD-MM-YYYY.E.g., 26-11-2015</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5>Response</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                  <b>200</b> Encrypted Response Format  {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <div class="card-body">
               <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/json</span></h6>
               <hr class="hr-col">
               </hr>
               <table class="sc-hHEiqL iZJLLY">
                  <tbody>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>The Aggregator id like “paygate”. We willprovide the value to be passed.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant ID issued to you by Safexpay.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>AG_ref id generated by the Safexpay during the transaction. It should be encrypted format.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="channel"><span class="sc-iemWCZ fhDkLh"></span><span>channel</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Use “WEB” in case of website based payment or “MOBILE” in case of mobile app.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_order_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_order_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the unique order number generated at your end when the request is initiated.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>List will be provided to you. E.g. “1” for HDFC Bank.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>List will be provided to you. NE = NEFT/RTGS</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="scheme"><span class="sc-iemWCZ fhDkLh"></span><span>scheme</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass hardcoded value “7” for NA.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Customer Name. This is required.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_email_id"><span class="sc-iemWCZ fhDkLh"></span><span>cust_email_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Customer’s Email ID. This is required and should be a valid email address.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_mobile_no"><span class="sc-iemWCZ fhDkLh"></span><span>cust_mobile_no</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Customer’s Mobile Number</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_ref_num"><span class="sc-iemWCZ fhDkLh"></span><span>cust_ref_num</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Customer’s Unique number generated in your system.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_account_number"><span class="sc-iemWCZ fhDkLh"></span><span>cust_account_number</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the registered bank account number of customer. Required in case of TPV</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_ifsc_code"><span class="sc-iemWCZ fhDkLh"></span><span>cust_ifsc_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the IFSC code of the registered bank account number. Required in case of TPV</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_bank_Name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_bank_Name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the registered bank name of customer. Required in case of TPV</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_bankbranch_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_bankbranch_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the branch name of the customer's bank. Example – Dadar</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr class="last undefined">
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_bankcity_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_bankcity_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>This is the city name of the customer's bank. Example – Mumbai</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>400 Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>404 Not found</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>500 server-error</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(252 239 239)", color: "rgb(212, 31, 28)", padding: "10px 15px" }} onClick={onClickCangeTab2}>
               <b>default</b> Succesfull Transaction  {TabCheck2 ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck2 &&
      <div>
         <div class="card-body">
            <h6 class="mt-10"><span>Response Schema:  </span>  <span style={{ color: "#313131" }}>Application/x-www-form-urlencode</span></h6>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 10 </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Aggregator ID.It's value must be AvantGarde</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant Id issued by Avantgrade</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is your Transaction ID for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;double&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is your Transaction Amount.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Country"><span class="sc-iemWCZ fhDkLh"></span><span>Country</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>ISO Country Code.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Currency"><span class="sc-iemWCZ fhDkLh"></span><span>Currency</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>ISO Currency Code.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 10 characters </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The transaction date and must be supplied in DD-MM-YY format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 8 characters </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>The transaction time and must be supplied in HH:MM:SS format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is Transaction ID generated by aggregator for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>This is Transaction ID generated by gateway for which you have initiated payment.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Successful"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Failed"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Holding"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Pending"</span> </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Transaction Status </p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 5 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Response Code. "0" for Success</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 200 ] </span></span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Response message explaining the failure reason. "0" for Success</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHide}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           pg_details {ShowHideAccordion ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordion &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           {ShowHideAccordion &&
                  <tr>
                  <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                  <div className="sc-dIvrsQ kPKTxr">
                  <table class="sc-hHEiqL iZJLLY"><tbody><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="senderKey"><span class="sc-iemWCZ fhDkLh"></span><span>senderKey</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;base64&gt; </span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>public key identifying the sender of the payload</p>
                  </div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 3 ] </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Bank Number. E.g. “1” for HDFC Bank</p>
                  </div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 50 ] </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Bank Name</p>
                  </div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div><div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"NB"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"DC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"PP"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"WA"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CE"</span> </div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Provides details about the paymode.<br/>
                  Valid values:<br/>
                  </p><ul>
                  <li>NB: Net Banking</li>
                  <li>CC: Credit Card</li>
                  <li>DC: Debit Card</li>
                  <li>PP: Prepaid Card</li>
                  <li>WA: Wallet</li>
                  <li>CE: Credit Card EMI</li>
                  </ul><p></p>
                  </div></div></div></td></tr><tr class="last undefined"><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div><div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"3"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"6"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"9"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"12"</span> </div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Tenure of EMI (3/6/9/12).Paymode must be Credit Card EMI (CCE).</p>
                  </div></div></div></td></tr></tbody></table>
                  </div>
                  </td>
                  </tr>
                  }
                  </div>
                  </td>
                  </tr>
                  }
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           fraud_details {ShowHideAccordionTwo ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionTwo &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Accept"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Reject"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Review"</span> </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Provides details about the fraud action. <br/>
                                                   Only if fraud engine is selected <br/>
                                                   Valid values:<br/>
                                                </p>
                                                <ul>
                                                   <li>Accept: Fraud not suspected. </li>
                                                   <li>Reject: Very strong fraud suspicion, reject the order. </li>
                                                   <li>Review:  Fraud suspected, review the customer details before processing the order. </li>
                                                </ul>
                                                <p></p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Fraud message describes the fraud in details.Only if fraud engine is selected.</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Risk scale</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
                  <tr className='expanded last undefined'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideThree}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           other_details {ShowHideAccordionThree ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionThree &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf1"><span class="sc-iemWCZ fhDkLh"></span><span>udf1</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf2"><span class="sc-iemWCZ fhDkLh"></span><span>udf2</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf3"><span class="sc-iemWCZ fhDkLh"></span><span>udf3</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf4"><span class="sc-iemWCZ fhDkLh"></span><span>udf4</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf5"><span class="sc-iemWCZ fhDkLh"></span><span>udf5</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>user defined field that you can use to send any additional information about the transaction</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
               </tbody>
            </table>
         </div>
      </div>
      }
   </div>
</div>
</div>
<div class="col-md-4 extreme-rt-div">
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
               <button> POST </button> /agcore/api/vpa/vaList  {TabCheck ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com</span><span
                  class="col-org">/agcore/api/vpa/vaList</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com</span><span
                  class="col-org">/agcore/api/vpa/vaList</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<RequestJSONflowthree/>
<ResponseJSONflowthree/>
</div>
</div>
</div>
</div>
)
}
export default ECollectAPI